<div class="viewport-wrapper">
  <div class="canvas-frame">
    <div id="hud" class="overlay hudOverlay">
      <canvas #canvas tabindex="1" id="canvas"></canvas>
      <div #textLayer class="overlay renderOverlay"></div>
    </div>
  </div>

  @if (loadingProgress) {
    <app-loading-overlay [progress]="loadingProgress" />
  }

  @if (scene && scene.debugManager.getEnabledState('fps')) {
    <app-perf-overlay [engine]="engine" [scene]="scene" />
  }

  @if (scene) {
    <div class="dev-panel" [class.collapsed]="devPanelCollapsed">
      <button class="dev-panel-toggle" (click)="devPanelCollapsed = !devPanelCollapsed">
        {{ devPanelCollapsed ? '&#9666; DEV' : '&#9656;' }}
      </button>

      <div class="dev-panel-content">
        <section class="dev-section">
          <h3 class="dev-section-title">Scene</h3>
          <select
            class="dev-select"
            (change)="switchScene($any($event.target).value); $any($event.target).blur()"
          >
            @for (scene of sceneList; track scene.id) {
              <option [value]="scene.path" [selected]="activeManifest === scene.path">
                {{ scene.name }}
              </option>
            }
          </select>
        </section>

        <section class="dev-section">
          <h3 class="dev-section-title">Control</h3>
          <div class="dev-mode-indicator">
            {{ playerController.controlMode === 'player' ? 'Player Mode' : 'Free Camera' }}
            <span class="dev-hint">(Tab)</span>
          </div>
          <button class="dev-btn" (click)="togglePlayerMode()">
            {{ playerController.controlMode === 'player' ? 'Free Camera' : 'Player Mode' }}
          </button>
          @for (cam of cameras; track cam.name) {
            <button
              class="dev-btn"
              (click)="playerController.setControlMode('free-camera'); engine.activeCamera = cam"
            >
              {{ cam.name }}
            </button>
          }
        </section>

        @if (deferredRenderer) {
          <section class="dev-section">
            <h3 class="dev-section-title">Graphics</h3>
            <button class="dev-btn" (click)="graphicsDialogOpen = true">Graphics Settings</button>
          </section>
        }

        <section class="dev-section">
          <h3 class="dev-section-title">Debug</h3>
          @for (option of scene.debugManager.debugOptions; track option) {
            <label class="dev-checkbox">
              <input
                type="checkbox"
                [checked]="scene.debugManager.getEnabledState(option)"
                (change)="scene.debugManager.setEnabledState(option, $any($event.target).checked)"
              />
              <span>{{ option }}</span>
            </label>
          }
        </section>

        @if (dayNightCycle) {
          <section class="dev-section">
            <h3 class="dev-section-title">Day / Night</h3>
            <label class="dev-checkbox">
              <input
                type="checkbox"
                [checked]="dayNightCycle.enabled"
                (change)="toggleCycle($any($event.target).checked)"
              />
              <span>auto cycle</span>
            </label>
            <label class="dev-range">
              <span class="dev-range-label"
                >time
                <span class="dev-range-value"
                  >{{ dayNightCycle.timeOfDay | number: '1.0-0' }}&deg;</span
                ></span
              >
              <input
                type="range"
                min="0"
                max="360"
                step="1"
                [value]="dayNightCycle.timeOfDay"
                (input)="setTimeOfDay($any($event.target).value)"
              />
            </label>
            <label class="dev-range">
              <span class="dev-range-label"
                >speed <span class="dev-range-value">{{ dayNightCycle.speed }}&deg;/s</span></span
              >
              <input
                type="range"
                min="1"
                max="60"
                step="1"
                [value]="dayNightCycle.speed"
                (input)="setCycleSpeed($any($event.target).value)"
              />
            </label>
          </section>
        }

        @if (physics) {
          <section class="dev-section">
            <h3 class="dev-section-title">Physics</h3>
            <button class="dev-btn" (click)="spawnBox()">Drop Box</button>
            <button class="dev-btn" (click)="launchProjectile()">Launch Projectile</button>
            <button class="dev-btn" (click)="launchArrow()">Fire Arrow</button>
          </section>
        }

        @if (cameraControls) {
          <section class="dev-section">
            <h3 class="dev-section-title">Free Camera</h3>
            <label class="dev-range">
              <span class="dev-range-label"
                >move speed
                <span class="dev-range-value">{{ cameraControls.moveSpeed.toFixed(2) }}</span></span
              >
              <input
                type="range"
                min="0.05"
                max="50"
                step="0.05"
                [value]="cameraControls.moveSpeed"
                (input)="setCameraSpeed($any($event.target).value)"
              />
            </label>
          </section>
        }

        <section class="dev-section">
          <h3 class="dev-section-title">Stress Test</h3>
          <label class="dev-range">
            <span class="dev-range-label"
              >point lights
              <span class="dev-range-value">{{ stressTestLights?.count ?? 0 }}</span></span
            >
            <input
              type="range"
              min="0"
              max="1000"
              step="1"
              value="0"
              (input)="setStressLightCount($any($event.target).value)"
            />
          </label>
        </section>
      </div>
    </div>
  }
  @if (graphicsDialogOpen && deferredRenderer) {
    <app-graphics-settings [renderer]="deferredRenderer" (closed)="graphicsDialogOpen = false" />
  }
</div>
<router-outlet></router-outlet>
